import React from 'react';
import Container from './Container';
import DetailTabs from '../DetailTabs';
import { Grid } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

const MobileDetail = () => {
  const location = useLocation();
  const { row, instruction, balance } = location.state;

  return (
    <Grid container direction="column">
      <Container row={row} inside balance={balance} />
      <DetailTabs row={row} instructions={instruction[0]} mobile />
    </Grid>
  );
};

export default MobileDetail;
